/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import {
  string,
  arrayOf,
  node,
  func,
  oneOfType,
  number,
  bool,
} from 'prop-types';
import { toKebabCase, getRuntimeEnvVariables } from 'helpers/Utils';
import classNames from 'classnames';
import { Small, HtmlParser } from 'components/common';

import './PromotionalBanner.scss';

const Footnotes = ({ footnotes = [] }) => {
  const footnoteWrapperClasses = {
    'footnote-wrapper': true,
    'full-width': footnotes.length === 1,
  };

  return (
    <div className="footnotes">
      {footnotes.map((footnote, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={footnote + index}
          className={classNames(footnoteWrapperClasses)}
        >
          <div className="footnote">
            <Small>
              {footnote}
            </Small>
          </div>
        </div>
      ))}
    </div>
  );
};

Footnotes.defaultProps = {
  footnotes: [],
};

Footnotes.propTypes = {
  footnotes: arrayOf(string),
};

const PromotionalBanner = (props) => {
  const {
    type,
    title,
    description,
    descriptionImg,
    footnotes = [],
    rightComponent,
    onClick = undefined,
    acceptsHTML,
    descriptionIconUrl,
    descriptionIconHeight,
  } = props;
  const noBanner = !type;

  // Change button text color on moneyhero
  const market = process.env.RAZZLE_MARKET;
  let colorType = type;
  if (market === 'moneyhero'
        && getRuntimeEnvVariables('RUNTIME_BRAND_REFRESHING') === 'true') {
      colorType = colorType === 'WELCOME_GIFT' || colorType === 'EXCLUSIVE'
          ? `mh-${colorType}`
          : colorType;
  }

  const classes = classNames({
    'promotional-banner': true,
    clickable: !!onClick,
    'main-banner-hidden-on-mobile': noBanner || !description,
    [toKebabCase(colorType)]: description && colorType,
  });
  const getPromotionalDescription = () => {
    if (descriptionImg) {
      return `${description}<img src="${descriptionImg}" class="promotional-text-image">`;
    }
    return description;
  };

  return (
    <div className={classes} onClick={onClick}>
      <div className={`main-banner-wrapper ${noBanner && 'no-banner'}`}>
        <div className="left-component">
          {!noBanner && description && (
            <div className="title-description-wrapper">
              {title && (
                <div className="title">
                  {`${title}:`}
                </div>
              )}
              <div className="description">
                {descriptionIconUrl && (
                  <img
                    className="description-icon"
                    src={descriptionIconUrl}
                    alt=""
                    height={descriptionIconHeight}
                  />
                )}
                {acceptsHTML ? (<HtmlParser htmlString={getPromotionalDescription()} />)
                    : getPromotionalDescription()}
              </div>
            </div>
          )}
          {footnotes && footnotes.length > 0 && (
            <div className="non-mobile-footnotes">
              <Footnotes
                footnotes={footnotes}
              />
            </div>
          )}
        </div>
        {rightComponent && (
          <div className="right-component">
            {rightComponent}
          </div>
        )}
      </div>
      {footnotes && footnotes.length > 0 && (
        <div className="mobile-footnotes">
          <Footnotes
            footnotes={footnotes}
          />
        </div>
      )}
    </div>
  );
};

PromotionalBanner.defaultProps = {
  type: null,
  title: null,
  description: null,
  descriptionImg: null,
  footnotes: [],
  onClick: undefined,
  rightComponent: null,
  acceptsHTML: true,
  descriptionIconUrl: null,
  descriptionIconHeight: 16,
};

PromotionalBanner.propTypes = {
  /**
   * The type of  Popular, Time limited, Exclusive offer, best value, special offer.
   */
  type: oneOfType([string, bool]),
  /**
   * Bold title displayed on the same line as description.
   */
  title: oneOfType([string, number]),
  /**
   * onclick function, noop by default
   */
  onClick: func,
  /**
   * Light text after the colon
   */
  description: string,
  /**
   * Image url after the description
   */
  descriptionImg: string,
  /**
   * An unordered list
   */
  footnotes: arrayOf(string),
  /**
   * an extra component on the right hand side
   */
  rightComponent: node,
  /**
   * acceptsHTML
   */
  acceptsHTML: bool,
  /**
   * An optional icon on the left hand side of description
   */
  descriptionIconUrl: string,
  /**
   * An optional icon on the left hand side of description
   */
  descriptionIconHeight: number,
};

export default PromotionalBanner;
